import request from '@/utils/request'

// 查询设备列表
export function listEquipment(query) {
  return request({
    url: '/system/equipment/list',
    method: 'get',
    params: query,
  })
}

// 查询设备分页
export function pageEquipment(query) {
  return request({
    url: '/system/equipment/page',
    method: 'get',
    params: query,
  })
}

// 查询设备详细
export function getEquipment(data) {
  return request({
    url: '/system/equipment/detail',
    method: 'get',
    params: data,
  })
}

// 新增设备
export function addEquipment(data) {
  return request({
    url: '/system/equipment/add',
    method: 'post',
    data: data,
  })
}

// 修改设备
export function updateEquipment(data) {
  return request({
    url: '/system/equipment/edit',
    method: 'post',
    data: data,
  })
}

// 删除设备
export function delEquipment(data) {
  return request({
    url: '/system/equipment/delete',
    method: 'post',
    data: data,
  })
}

// 导入设备数据
export function importEquipmentData(data) {
  return request({
    url: '/system/equipment/importData',
    method: 'post',
    data: data,
  })
}

// 修改设备状态
export function changeEquipmentStatus(data) {
  return request({
    url: '/system/equipment/editStatus',
    method: 'post',
    data: data,
  })
}
